export const SAME_AS_TYPES = {
    SAME_AS_OPERATOR: "SAME_AS_OPERATOR",
    SAME_AS_BILLING: "SAME_AS_BILLING",
    SAME_AS_OWNER: "SAME_AS_OWNER",
    CREATE_NEW_ADDRESS: "CREATE_NEW_ADDRESS"
};
